import React from "react";
import { SelectInputProps, SelectInput } from ".";
import { NamePath } from "antd/lib/form/interface";
import { Form } from "antd";

type RecurrenceInputProps = {
  dateProp: NamePath;
} & Omit<SelectInputProps<string>, 'options'>;

function getOptions(date?: moment.Moment) {
  if (!date) {
    return []
  };

  return [
    { value: '', display: 'Does not repeat' },
    { value: 'RRULE:FREQ=DAILY', display: 'Daily' },
    { value: 'RRULE:FREQ=WEEKLY', display: `Weekly on ${date.format('dddd')}` },
    { value: `RRULE:FREQ=WEEKLY;WKST=SU;INTERVAL=2;BYDAY=${date.format('dd').toUpperCase()}`, display: `Fortnightly` },
    { value: 'RRULE:FREQ=MONTHLY', display: 'Monthly' },
    { value: 'RRULE:FREQ=YEARLY', display: `Yearly on ${date.format('MMMM D')}` },
    { value: `RRULE:FREQ=WEEKLY;WKST=SU;BYDAY=MO,TU,WE,TH,FR`, display: `Every weekday (Monday to Friday)`},
  ];
}

export function RecurrenceInput(props: RecurrenceInputProps) {
  const form = Form.useFormInstance();
  const date: moment.Moment = Form.useWatch(props.dateProp, form);
  const options = getOptions(date);
  return <SelectInput {...props} options={options} />;
}
